import { ReactNode, CSSProperties } from 'react'
import './Card.css'

interface CardProps {
  children: ReactNode
  className?: string
  onClick?: () => void
  style?: CSSProperties
}

function Card({ children, className = '', onClick, style }: CardProps) {
  return (
    <div
      className={`card ${className} ${onClick ? 'card--clickable' : ''}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  )
}

export default Card

